const MEGA_MENU_ID = 'mega-menu';

export default {
    MEGA_MENU_ID
};
